import Head from 'next/head';
import getMetaTagData from '../src/common/services/getMetaTagData';
// import adGenerater from '../src/common/services/adGenerater';

import SitemapCont from '../src/component/pc/sitemap/SitemapCont';

import { sitemap } from '../src/common/constants';

function Home ({ metaTagData }) {
  return (
    <div id='container' className='contents'>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />

        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div className='sitemap_list_wrap'>
        <div className='contents_area_sitemap'>
          <div className='module_titleline_w'>
            <h2 className='module_titleline_title'>사이트맵</h2>
          </div>
          {sitemap.map((row, rowNum) => {
            return (
              <div className='sbs_sitemap_cont' key={rowNum}>
                {row.map((item, idx) => {
                  return (
                    <SitemapCont
                      key={`${rowNum}-${idx}`}
                      sectionTitle={item.sectionTitle}
                      sectionList={item.sectionList}
                    />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>

    </div>

  );
}

export async function getServerSideProps (ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const metaTagData = getMetaTagData(ctx.req.url);

  metaTagData.shareTitle = 'SBS 사이트 맵';

  return { props: { metaTagData } };
}

export default Home;
